import { handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import { GET_CROSS_SELL_OFFER_PACKAGES } from '../actions/cross-sell-offer-actions';

const { REQUEST, SUCCESS, FAILURE } = httpActions;

export const initialState = {
  crossSellOfferPackages: [
    //    applicationUuid: '',
    //    crossSellApplicationUuid: '',
    //    decision: '',
    //    identityUuid: '',
    //    lienVerificationRequired: false,
    //    max: 0,
    //    maxLoanAmountByProduct: 0,
    //    min: 0,
    //    offers: [
    //      {
    //        index: 0
    //        intRate: 0,
    //        maxAmount: 0,
    //        minAmount: 0,
    //        originationFee: 0,
    //        rateDiscountResponse: []
    //        rateType: '',
    //        term: 0,
    //      }
    //    ],
    //    productType: '',
    //    subDecision: '',
    //    termsList: [],
    // }]
  ],
  loading: false,
};

function parseOffersMinMax(offers = []) {
  const reduce = (accValue, value, mathTask) => (typeof accValue === 'undefined' ? value : mathTask(accValue, value));

  return offers.reduce(
    (acc, o) => ({
      min: reduce(acc.minAmount, o.minAmount, Math.min),
      max: reduce(acc.maxAmount, o.maxAmount, Math.max),
    }),
    {
      min: undefined,
      max: undefined,
    }
  );
}

const parseOffersTermsList = (offers) =>
  offers.reduce((termsList, currentOffer) => {
    if (!termsList.includes(currentOffer.term)) termsList.push(currentOffer.term);
    return termsList;
  }, []);

const reducer = handleActions(
  {
    [`${GET_CROSS_SELL_OFFER_PACKAGES}_${REQUEST}`](state = initialState) {
      return {
        ...state,
        loading: true,
      };
    },
    [`${GET_CROSS_SELL_OFFER_PACKAGES}_${SUCCESS}`](state, action) {
      const crossSellOfferPackages =
        action.payload?.map((offerPackage) => {
          const minMax = parseOffersMinMax(offerPackage.offers);
          const termsList = parseOffersTermsList(offerPackage.offers);

          return {
            ...offerPackage,
            min: minMax.min,
            max: minMax.max,
            termsList,
          };
        }) ?? [];

      return {
        ...state,
        crossSellOfferPackages,
        loading: false,
      };
    },
    [`${GET_CROSS_SELL_OFFER_PACKAGES}_${FAILURE}`](state) {
      return {
        ...state,
        loading: false,
      };
    },
  },
  initialState
);

export default reducer;
